module.exports = __webpack_public_path__ + "static/media/covid-19.7401e4ec.jpg";